module.exports = __webpack_public_path__ + "img/ringcase.c0f4603.webp";